
import type { PropType } from 'vue'
import type { DateRange } from '../../models/domain/date-range'
import { computed, defineComponent } from 'vue'
import { DateRangeUtils } from '../../utils/date-range.utils'
import { DateUtils } from '../../utils/date.utils'

export default defineComponent({
  props: {
    date: {
      required: true,
      type: Date as PropType<Date>,
    },
    dateRange: {
      required: true,
      type: Object as PropType<DateRange>,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(props) {
    const classes = computed((): Array<string | Record<string, boolean>> => {
      const dateRange = props.dateRange as DateRange
      return [
        'date',
        {
          'date--today': DateUtils.isDateToday(props.date),
          'date--range-start': DateRangeUtils.isDateRangeStartDate(dateRange, props.date),
          'date--range':
            DateRangeUtils.isDateRangeStartDate(dateRange, props.date) ||
            DateRangeUtils.isDateRangeEndDate(dateRange, props.date) ||
            DateRangeUtils.isDateInRange(dateRange, props.date),
          'date--range-end': DateRangeUtils.isDateRangeEndDate(dateRange, props.date),
          'rounded-right':
            DateUtils.isEndOfMonth(props.date) ||
            DateRangeUtils.isDateRangeEndDate(dateRange, props.date) ||
            (DateRangeUtils.isDateRangeStartDate(dateRange, props.date) &&
              !DateRangeUtils.isDateRangeComplete(dateRange)),
          'rounded-left':
            DateUtils.isStartOfMonth(props.date) ||
            DateRangeUtils.isDateRangeStartDate(dateRange, props.date),
          'date--disabled': props.disabled,
        },
      ]
    })
    return {
      classes,
    }
  },
})
